/*
 *
 *  This directive builds a standard cron timer selector
 *
 */

import template from './scheduler.html';

export default {
  name: 'scheduler',
  template,
  bindings: {
    options: '<',
    timeObject: '<',
    index: '<',
    removeSchedule: '&'
  }
};
